import {
  APPOINTMENT_REQUEST,
  APPOINTMENT_FAILURE,
  FETCH_APPOINTMENT_SUCCESS,
  CREATE_APPOINTMENT_SUCCESS,
  DELETE_APPOINTMENT_SUCCESS,
  UPDATE_APPOINTMENT_SUCCESS,
  GET_APPOINTMENT_SUCCESS,
  FETCH_RECEPTION_SCHEDULE_SUCCESS,
  CREATE_RECEPTION_LOCATION_SUCCESS,
  UPDATE_RECEPTION_LOCATION_SUCCESS,
  DELETE_RECEPTION_LOCATION_SUCCESS,
  CREATE_RECEPTION_SCHEDULE_SUCCESS,
  UPDATE_RECEPTION_SCHEDULE_SUCCESS,
  DELETE_RECEPTION_SCHEDULE_SUCCESS,
  UPDATE_RECEPTION_DAILY_SUCCESS,
} from "../action/types";

const initialState = {
  appointments: [],
  total: 0,
  currentAppointment: null,
  locations: [],
  schedules: [],
  daily: null,
  loading: false,
  error: null,
};

const appointmentReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case APPOINTMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        appointments: Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(payload)
            ? payload
            : [],
        total: payload?.total ?? (Array.isArray(payload) ? payload.length : 0),
      };

    case GET_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        currentAppointment: payload,
        appointments: state.appointments.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case FETCH_RECEPTION_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        locations: Array.isArray(payload?.locations) ? payload.locations : [],
        schedules: Array.isArray(payload?.schedules) ? payload.schedules : [],
        daily: payload?.daily || null,
      };

    case CREATE_RECEPTION_LOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        locations: [...state.locations, payload],
      };

    case UPDATE_RECEPTION_LOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        locations: state.locations.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case DELETE_RECEPTION_LOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        locations: state.locations.filter((item) => item.id !== payload),
      };

    case CREATE_RECEPTION_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        schedules: [...state.schedules, payload],
      };

    case UPDATE_RECEPTION_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        schedules: state.schedules.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case DELETE_RECEPTION_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        schedules: state.schedules.filter((item) => item.id !== payload),
      };

    case UPDATE_RECEPTION_DAILY_SUCCESS:
      return {
        ...state,
        loading: false,
        daily: payload,
      };

    case CREATE_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        appointments: [payload, ...state.appointments],
        total: state.total + 1,
      };

    case UPDATE_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        appointments: state.appointments.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case DELETE_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        appointments: state.appointments.filter((item) => item.id !== payload),
        total: Math.max(0, state.total - 1),
      };

    case APPOINTMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default appointmentReducer;
